<template>
  <Viewer :isOpenBookCats="openBookCats" :valOpenSidebar="typeOpenSidebar" :linkBack="otherInfo ? { name:'exercise', query:{ lop: otherInfo.classId, mon: otherInfo.subjectId, tab: typeId} } : {}">
    <template v-if="otherInfo" v-slot:viewer_head_name>{{ otherInfo.title }}</template>
    <template v-if="otherInfo" v-slot:viewer_head_right>{{ versionApp }}</template>
    <template v-slot:viewr_body>
      <div class="exercise-detail__questions position-rel">
        <div class="exercise-detail__list">
          <ExerciseQuestionList v-if="questionCurr === 0 && questionsSaved" :dataSource="questionsSaved" @handleGoQuestion="directQuestion" />
          <div v-else class="item position-rel content-1">
              <div class="question-group" v-if="question && question.type && question.type === typeGroup">
                  <PreviewQuestion 
                      :dataSource="question"
                      :questions="[question]"
                      :location="0"
                      :preview="true"
                      :questionsData="question"
                      @formatQuestion="getInfoQuestion"
                      @getResultQuestion="getResultQuestion"
                      @answerMissing="handleAnswerMissing"
                  />
                  <div class="questions-child" v-if="question.listQuestionChild">
                      <div class="questions-child__item" v-for="(child, pos) of question.listQuestionChild">
                          <PreviewQuestion 
                              v-if="child"
                              :dataSource="child"
                              :location="pos"
                              :parentIndex="0"
                              :isQuestionChild="true"
                              :preview="true"
                              :questionsData="question"
                              @formatQuestion="getInfoQuestion"
                          />
                      </div>
                  </div>
                  <p v-if="txtMissingQuestionGroup" class="question-missing-answer color-err">{{ txtMissingQuestionGroup }}</p>
              </div>
              <div class="question-single" v-else-if="question">
                  <PreviewQuestion 
                      :dataSource="question"
                      :location="0"
                      :preview="true"
                      @getResultQuestion="getResultQuestion"
                      @formatQuestion="getInfoQuestion"
                      @answerMissing="handleAnswerMissing"
                  />
              </div>
          </div>
        </div>
        <div v-if="questionCurr > 0" class="exercise-detail__feedback display-flex-center justify-content-between">
          <a
            href="javascript:;"
            v-if="!showGuideContent"
            class="secondary-color-txt"
            @click="toggleGuideContent"
          >Xem hướng dẫn</a>
          <a
            href="javascript:;"
            v-else
            class="primary-color"
            @click="toggleGuideContent"
          >Ẩn hướng dẫn</a>
        </div>
        <div class="exercise-detail__guide" v-if="showGuideContent">
          <b-tabs content-class="mt-3">
            <b-tab title="Hướng dẫn ">
              <div class="exercise-detail__guide__content font-size-16 primary-color-txt">
                <span class="display-block font-size-16 secondary-color-txt font-sanpro">{{ versionApp }}</span>
                <template v-if="question && question.type && question.type === typeGroup">
                  <div class="child-item" v-for="(guide, index) of question.listQuestionChild" :key="`guide_${index}`">
                    <b v-if="guide && guide.title">{{ guide.title }}</b>
                    <div v-if="guide && guide.guideContent" class="guide__content" v-html="guide.guideContent"></div>
                  </div>
                </template>
                <div v-else class="guide__content" v-html="question.guideContent"></div>
              </div>
            </b-tab>
            <b-tab title="Lời giải chi tiết">
                <span class="display-block font-size-16 secondary-color-txt font-sanpro">{{ versionApp }}</span>
              <div class="exercise-detail__guide__content font-size-16 primary-color-txt">
                <template v-if="question && question.type && question.type === typeGroup">
                  <div class="child-item" v-for="(and, index) of question.listQuestionChild" :key="`and_${index}`">
                    <b v-if="and && and.title">{{ and.title }}</b>
                    <div v-if="and && and.answerDetail" class="answer__detail__content" v-html="and.answerDetail"></div>
                  </div>
                </template>
                <div v-else class="answer__detail__content" v-html="question.answerDetail"></div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <div class="overlay-question" v-if="valVituralKeyboard.location > -1 && screenWidth > 991 && questionCurr !== 0" @click="resetValKeyboard"></div>
      </div>
    </template>
    <template v-slot:viewer_sidebar_icon>
      <!-- <a href="javascript:;" :class="{'active': keySidebarActive === 'search'}" @click="openSidebar('search')"><i class="icon-search font-size-24"></i></a> -->
      <a href="javascript:;" :class="{'active': keySidebarActive === 'link'}" @click="openSidebar('link')"><i class="icon-link font-size-24"></i></a>
    </template>
    <template v-slot:viewer_sidebar_content>
      <div class="sidebar__search" v-if="keySidebarActive === 'search'">
        <h3 class="sidebar__title">Tra cứu</h3>
        <div class="sidebar__search__form">
          <div class="input-custom-icon">
            <input type="text" name="search" autocomplete="off" />
            <i class="fas fa-search primary-color"></i>
          </div>
        </div>
        <div class="sidebar__search__result">
          <b-tabs class="sidebar__tabs">
            <b-tab active>
              <template v-slot:title>Trang</template>
              <div class="result-pages">
                <a href="javascript:;" class="item">
                  <img src="http://d1rfjjhpkkmj6r.cloudfront.net/uploads/books/toan-1-tap-1-1.jpg" alt="12">
                  <span>12</span>
                </a>
              </div>
            </b-tab>
            <b-tab>
              <template v-slot:title>Bài</template>
              <ul class="result-lesson margin-0">
                <li><a href="javascript:;">Tên bài học</a></li>
              </ul>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <div class="sidebar-link" v-if="keySidebarActive === 'link'">
        <div class="sidebar-link__head">
          <div class="book-viewer__sidebar__contents__wrap">
            <h3 class="sidebar__title">Liên kết</h3>
          </div>
        </div>
        <div class="sidebar__link__result">
          <div class="book-viewer__sidebar__contents__wrap">
            <b-tabs class="sidebar__tabs">
              <b-tab active>
                <template v-slot:title>Luyện tập</template>
                <div class="book-links">
                  <vue-custom-scrollbar class="scroll-area scroll-area__sidebar" :settings="settingsViewBookSidebar">
                    <div class="item display-flex full-width">
                      <div class="item__img">
                        <router-link to="/">
                          <img src="http://d1rfjjhpkkmj6r.cloudfront.net/uploads/books/toan-1-tap-1-1.jpg" alt="Sách giáo khoa môn Toán 1 (Tập 1)">
                        </router-link>
                      </div>
                      <div class="item__content">
                        <h4 class="item__name font-size-16 font-sanpro-semibold primary-color-txt margin-0">
                          <router-link to="/" class="color-inherit">Sách giáo khoa môn Toán 1 (Tập 1)</router-link>
                        </h4>
                        <p class="item__year font-size-14 secondary-color-txt">Tái bản: 2020</p>
                        <router-link to="/" class="btn btn-main-light border-rd-20 font-size-15 font-sanpro-semibold">Đọc sách</router-link>
                      </div>
                    </div>
                  </vue-custom-scrollbar>
                </div>
              </b-tab>
              <b-tab active>
                <template v-slot:title>Sách điện tử</template>
                <div class="book-links">
                  <vue-custom-scrollbar class="scroll-area scroll-area__sidebar" :settings="settingsViewBookSidebar">
                    <div class="item display-flex full-width" v-for="(item, index) of bookRelates">
                      <div class="item__img">
                        <router-link :to="{ name: 'ebook-detail', params: { id: item.bookId, slug: item.slug }}">
                          <img :src="item.imageUrl ? cdnUrl + item.imageUrl : ''" :alt="item.name">
                        </router-link>
                      </div>
                      <div class="item__content">
                        <h4 class="item__name font-size-16 font-sanpro-semibold primary-color-txt margin-0">
                          <router-link :to="{ name: 'ebook-detail', params: { id: item.bookId, slug: item.slug }}" class="color-inherit">{{ item.name }}</router-link>
                        </h4>
                        <p class="item__year font-size-14 secondary-color-txt">Tái bản: {{ item.editionYear }}</p>
                        <router-link :to="{ name: 'ebook-detail', params: { id: item.bookId, slug: item.slug }}" target= '_blank' class="btn btn-main-light border-rd-20 font-size-15 font-sanpro-semibold">Đọc sách</router-link>
                      </div>
                    </div>
                  </vue-custom-scrollbar>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:viewer_toggle_cat_name>Mục lục</template>
    <template v-slot:viewer_footer_right>
      <div class="exercise-detail__direct display-flex-center">
        <div class="book-viewer__paging display-flex-center">
            <a href="javascript:;" v-b-tooltip.hover title="Danh mục trước" @click="prevCatBook" :class="{'disabled': parseInt(indexCatCurr) <= 0}">
              <i class="icon-first-page primary-color font-size-24"></i>
            </a>
            <a href="javascript:;" v-b-tooltip.hover title="Câu hỏi trước" @click="prevQuestion" :class="{'disabled': parseInt(questionCurr) <= 1}">
              <i class="icon-prev primary-color font-size-24"></i>
            </a>
            <a href="javascript:;" v-b-tooltip.hover title="Câu hỏi tiếp theo" @click="nextQuestion" :class="{'disabled': parseInt(questionCurr) >= parseInt(questionList.length)}">
              <i class="icon-next primary-color font-size-24"></i>
            </a>
            <a href="javascript:;" v-b-tooltip.hover title="Danh mục tiếp theo" @click="nextCatBook" :class="{'disabled': parseInt(indexCatCurr) >= thematicCatLength - 1}">
                <i class="icon-last-page primary-color font-size-24"></i>
            </a>
        </div>
      </div>
      <a 
        href="javascript:;"
        class="btn btn-main font-size-16 font-sanpro-semibold border-rd-20"
        v-if="questionCurr !== 0 && question" 
        :class="{'disabled': (question && (question.type === typeDrawShape || question.type === typeDownAnswer)) || questionCurr === 0 || question.isWorked || question.statusWorked}" 
        @click="checkAnswer"
      >Kiểm tra</a>
    </template>
    <template v-slot:viewer_sidebar_cat_head>
      <div class="exercise-detail__cats__breadcrumb">
        <ul class="margin-0 p-0 text-left">
            <li class="word-excerpt" v-for="(bread, index) of breadCrumbCurr" :class="{'active': index === breadCrumbCurr.length - 1 && questionCurr === 0}">
                <a href="javascript:;" @click="index === breadCrumbCurr.length - 1 && breadCrumbCurr.length > 1 ? getQuestionData(bread) : directExerciseCat(breadCrumbCurr[breadCrumbCurr.length - 1])">
                  <span v-if="index === 0" class="icon-arrow-left font-size-13 secondary-color-txt position-rel"><span class="path1"></span><span class="path2"></span></span>
                  {{bread.title}} 
                </a>
                <span v-if="index === breadCrumbCurr.length - 1" class="btn-reset" @click="resetAnswers">
                  <i class="icon-reset primary-color font-size-18"></i>
                </span>
            </li>
            <!-- <span class="display-block font-size-16 secondary-color-txt font-sanpro">(Phiên bản 1.0)</span> -->
        </ul>
      </div>
    </template>
    <template v-slot:viewer_sidebar_cat_body>
      <div class="book-viewer__cats__list exercise-detail__cats__list">
        <a class="item" 
          v-for="(item, index) of questionList" 
          :class="{
              'curr': item.current, 
              'success': (item.answerStatus !== null && item.answerStatus === 'success') || (item.statusWorked && !item.workedFail) || (item.isWorked && item.isTrue), 
              'error': (item.answerStatus !== null && item.answerStatus === 'error') || (item.statusWorked && item.workedFail === 'error') || (item.isWorked && !item.isTrue) 
          }" 
          @click="directQuestion(index + 1)"
        >
          {{ item.name }}
        </a>
      </div>
    </template>
    <template v-slot:viewer_footer>
      <VituralKeyboard v-if="valVituralKeyboard.location > -1 && screenWidth > 991" :class="{'open-cat': openBookCats, 'over-height': valVituralKeyboard && valVituralKeyboard.isOverHaflScreen}" />
      <audio v-if="actionPlayQuestionTrue" id="question_true" :src="correct" autoplay></audio>
      <audio v-if="actionPlayQuestionFalse" id="question_false" :src="incorrect" autoplay></audio>
    </template>
  </Viewer>
</template>

<script>
    import {mapGetters, mapActions, mapState} from 'vuex';
    import { TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question/_store/constants'
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import { APP_CONFIG } from '@/utils/constants'
    import PreviewQuestion from '@/modules/question/preview-question/PreviewQuestion.vue'
    import { getQuestionsSidebar, getQuestionDetail, getQuestionsByCat, getDetailOfOtherOrThematic, getQuestionListOfOtherOrThematic, getCatOfExerciseOtherOrThematic, saveUserWorkQuestion, resetResultCorrectQuestionOtherOrThematic, getQuestionListInSidebarOfThematicOrOther } from './../../_api/'
    import { STORE_KEY, LOCAL_SAVE_QUESTIONS_WORKED, LOCAL_SAVE_CAT, LOCAL_SAVE_BOOK_ACTIVE, LOCAL_SAVE_EXERCISE_CLASS, LOCAL_QUESTIONS_DATA, TYPE_EXERCISE_OTHER } from "./../../_store/constants";
    import ExerciseQuestionList from './../../_components/ExerciseQuestionList.vue'
    // import ActiveCode from '@/modules/ebooks/_components/common/ActiveCode.vue'
    import mixinExercise from './../../_store/mixinExercise'
    import { getAuth } from '@/utils/jwt'
    import { EMAIL_PUBLIC } from '@/store/auth/constants'
    import VituralKeyboard from '@/modules/question/preview-question/VituralKeyboard.vue'
    import { STORE_KEY as STORE_KEY_QUESTION } from '@/modules/question/preview-question/_store/constants'
    const correct = require('@/assets/audio/correct.mp3')
    const incorrect = require('@/assets/audio/incorrect.mp3')
    import Viewer from '@/layouts/Viewer.vue'
   
    export default {
        name: 'OtherQuestion',
        mixins: [ mixinExercise ],
        components: {
            vueCustomScrollbar,
            PreviewQuestion,
            ExerciseQuestionList,
            // ActiveCode,
            VituralKeyboard,
            Viewer
        },
        data() {
          return {
            typeGroup: TYPE_GROUP,
            typeDrawShape: TYPE_DRAW_SHAPE_ANSWER,
            typeDownAnswer: TYPE_DOWN_ANSWER,
            typefillBlank: TYPE_FILL_BLANK,
            typeSelect: TYPE_SELECT,
            typeMatchCol: TYPE_MATH_COL,
            cdnUrl: APP_CONFIG.cdnUrl,
            settingsViewBookSidebar: {
              maxScrollbarLength: 300,
            },
            isOpenSidebar: false,
            typeOpenSidebar: {},
            keySidebarActive: '', // search ||'link'
            openBookCats: true,
            openSidebarMobile: false,
            showGuideContent: false,
            tabGuideActive: 0,
            questionindexActive: null,
            questionsSaved: [],
            questionList: [],
            questionsLoaded: [],
            question: null,
            bookRelates: [],
            arrResultCorrect: [],
            catExercise: null,
            otherInfo: null,
            // exerciseBookActive: null,
            breadCrumbCurr: [],
            txtMissingQuestionGroup: '',
            indexCatCurr: 0,
            thematicCatLength: 0,
            authInfo: {},
            catsFlat: [],
            setValQuestionChange: {},
            correct,
            incorrect,
            actionPlayQuestionTrue: false,
            actionPlayQuestionFalse: false,
            handleNextPrevCat: '', //next or prev
            dataCatsThematic: []
          }
        },
        computed: {
          ...mapState(STORE_KEY, ['paramsFilterExOtherThematic']),
          ...mapState('auth', ['loginPopupData']),
          ...mapState(STORE_KEY_QUESTION, ['valVituralKeyboard']),
          ...mapGetters({
              actionCheckQuestion: `common/actionCheckQuestion`,
          }),
          routerParams() {
            return this.$route.params;
          },
          classId() {
            return parseInt(this.$route.params.classId);
          },
          subjectId() {
            return parseInt(this.$route.params.subjectId);
          },
          screenWidth() {
            return window.innerWidth;
          },
          otherId() {
            return parseInt(this.$route.params.id);
          },
          typeId() {
            return parseInt(this.$route.params.typeId);
          },
          questionCurr() {
            return parseInt(this.$route.params.question);
          },
          ...mapState('common', ['versionApp'])
        },
        watch: {
            '$route.params.question': 'getInfoQuestion',
            actionCheckQuestion(newVal) {
                !newVal && this.setQuestionResult();
            },
            '$route.params.id': 'getQuestionNewThematic',
            valVituralKeyboard(newVal) {
              if(newVal.ref) {
                document.getElementById(newVal.ref).value = newVal.val;
                document.getElementById(newVal.ref).focus();
              }
            }
        },
        created() {
            this.getOtherInfo();
            this.getQuestionListOfSidebar();
            this.authInfo = getAuth();
        },
        mounted () {
            this.getInfoSaveLocal();
            this.getCatsOfThematic();
        },
        destroyed () {
            this.resetValKeyboard();
            localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED)
            localStorage.removeItem(LOCAL_QUESTIONS_DATA)
        },
        methods: {
            ...mapActions('common', ['setLoading', 'setActionCheckQuestion', 'setToggleModalActivePage', 'acSetDataBookActiveWant', 'acToggleModalActiveBook']),
            ...mapActions(STORE_KEY, ['actionBookIndexOfBook', 'acSetParamFilterOtherThematic']),
            ...mapActions(STORE_KEY_QUESTION, ['setVituralKeyVal', 'setQuestionData4CheckAnswer', 'setQuestionList4CheckAnswer']),

            getCatsOfThematic() {
                let self = this;
                // if(!self.bookIndexOfBook || self.bookIndexOfBook.length === 0) {
                  self.acSetParamFilterOtherThematic({...self.paramsFilterExOtherThematic, classId: self.classId, subjectId: self.subjectId, type: TYPE_EXERCISE_OTHER})
                  getCatOfExerciseOtherOrThematic(self.paramsFilterExOtherThematic).then(async res => {
                      if(res && res.data && !res.errors) {
                          self.dataCatsThematic = await self.flatenCatsExOtherOrThematic(res.data)
                          self.thematicCatLength = self.dataCatsThematic.length
                          // Save bookIndex into state
                          setTimeout(() => {
                            self.setBreadCrumbCurr(self.dataCatsThematic);
                          }, 100)
                          
                      }
                  }).catch().finally(() => self.setLoading(false));
                // } else {
                //     self.setBreadCrumbCurr();
                // }
            },

            setBreadCrumbCurr() {
                this.breadCrumbCurr = [];
                if(this.dataCatsThematic && this.dataCatsThematic.length > 0) {
                  this.indexCatCurr = this.dataCatsThematic.findIndex(cat => cat.chapterId === this.otherId);
                  if(this.indexCatCurr > -1) {
                    const { chapterId, title } = this.otherInfo
                    this.breadCrumbCurr = [...this.dataCatsThematic[this.indexCatCurr].parents, {chapterId, title}]
                  }
                }
            },

            getQuestionNewThematic() {
              this.setLoading(true)
              let indexCatActive = this.dataCatsThematic.findIndex(cat => cat.chapterId === this.otherId)
              if(indexCatActive > -1) {
                this.otherInfo = this.dataCatsThematic[indexCatActive]
              }
              Promise.all([this.getQuestionListOfSidebar(), this.fetchQuestionList(), this.setBreadCrumbCurr()])
            },

            getInfoSaveLocal() {
                let catInfo = localStorage.getItem(LOCAL_SAVE_CAT);
                let practiceData = localStorage.getItem(LOCAL_SAVE_EXERCISE_CLASS);
                let questionData = localStorage.getItem(LOCAL_QUESTIONS_DATA);
               
                if(questionData && questionData !== null && questionData !== undefined) {
                  this.questionsSaved = JSON.parse(questionData);
                } else {
                  this.fetchQuestionList()
                }
              
            },

            getOtherInfo() {
                let self = this;
                getDetailOfOtherOrThematic(self.otherId).then(res => {
                  if(res && res.data && !res.errors) {
                    self.otherInfo = res.data;
                  }
                })
            },

            getQuestionListOfSidebar() {
                let self = this;
                self.setLoading(true);
                self.questionList = [];
                
                getQuestionListInSidebarOfThematicOrOther(self.otherId).then(res => {
                    self.questionList = res && res.data && !res.errors ? res.data : [];
                    if(res && res.data && res.data.length > 0) {
                        // Set box size
                        self.setSpaceSizeForOpenCatBox();

                        self.getInfoQuestion();
                        // Get question checked
                        self.setQuestionResult();
                    } else {
                        self.setLoading(false)
                    }
                }).catch().finally(() => self.setLoading(false));
            },

            getInfoQuestion() {
                let self = this;
                self.question = null;
                // Hidden guide content
                self.showGuideContent = false;
                // self.arrResultCorrect = [];
                self.questionindexActive = self.$route.params.question;
                if(self.questionindexActive > 0) {
                    self.setLoading(true);
                    let questionId = self.questionList[self.questionCurr - 1].questionId;
                    let questionsLocalStorage = JSON.parse(localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED));

                    if(questionsLocalStorage && questionsLocalStorage !== null && questionsLocalStorage !== undefined && questionsLocalStorage.length > 0) {
                        let indexQuestionSave = questionsLocalStorage.findIndex(ques => ques.questionId === questionId);
                        if(indexQuestionSave > -1) {
                            self.question = questionsLocalStorage[indexQuestionSave];
                            self.setLoading(false);
                        } else {
                            self.getQuestionDetail(questionId, questionsLocalStorage);
                        }
                    } else {
                        self.getQuestionDetail(questionId);
                    }

                    self.setQuestionCurr();
                }
            },

            getQuestionDetail(questionId, dataQuestion = []) {
                let self = this;
                // Get question detail
                getQuestionDetail(questionId).then(res => {
                    if(res && res.data && !res.errors) {
                        self.question = res.data;
                        let dataSave = dataQuestion.length === 0 ? [res.data] : [...dataQuestion, res.data];
                        self.saveLocalQuestion(dataSave);
                    }
                }).catch().finally(() => self.setLoading(false));
            },

            saveLocalQuestion(data) {
                let dataSave = JSON.stringify(data);
                localStorage.setItem(LOCAL_SAVE_QUESTIONS_WORKED, dataSave);
            },

            setQuestionCurr() {
                let self = this;
                // Set question current
                self.questionList.map((que, index) => {
                    que['current'] = (parseInt(index) === parseInt(self.questionindexActive) -1) ? true : false;
                })
            },

            setQuestionResult() {
                let self = this;
                let questionsLocalStorage = JSON.parse(localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED));
                if(questionsLocalStorage && questionsLocalStorage !== null && questionsLocalStorage !== undefined && questionsLocalStorage.length > 0) {
                    questionsLocalStorage.map((ques, index) => {
                        if( ques.statusWorked ) {
                            let resultCheckAnswer = ques.workedFail ? 'error' : 'success';
                            let indexQuestionInList = self.questionList.findIndex(queList => queList.questionId === ques.questionId);
                            if(indexQuestionInList > -1) {
                                self.questionList[indexQuestionInList].answerStatus = resultCheckAnswer;
                                self.logQuestionWorked(resultCheckAnswer);
                            }
                        }
                    }) 
                }
            },

            logQuestionWorked(status) {
              this.question['isTrue'] = status === 'success' ? true : false;
              this.question['isWorked'] = true;
            },

            openSidebar(type) {
              if(type !=null){
                this.typeOpenSidebar = {type, isOpen: type === this.keySidebarActive ? false : true}
                this.keySidebarActive = type !== this.keySidebarActive ? type : ''
              }
            },

            handleToggleBookCats() {
              let self = this;
              self.openBookCats = !self.openBookCats;
              self.isOpenSidebar = false;
              self.keySidebarActive = '';

              if(self.openBookCats) {
                self.setSpaceSizeForOpenCatBox()
              } else {
                self.resetPageWhenOfBoxsTransition();
              }
            },

            setSpaceSizeForOpenSidebarBox() {
              let self = this;
              let bodyBookBox = document.getElementsByClassName('book-viewer__body')[0];
              let sidebarBox = document.getElementsByClassName('book-viewer__sidebar')[0];
              let widthSidebarBox = sidebarBox.clientWidth;

              bodyBookBox.style.paddingLeft = 0;
              bodyBookBox.style.paddingRight = `${widthSidebarBox}px`;
            },

            setSpaceSizeForOpenCatBox() {
              let self = this;
              let bodyBookBox = document.getElementsByClassName('book-viewer__body')[0];
              let catBox = document.getElementsByClassName('book-viewer__cats')[0];
              let widthCatBox = catBox.clientWidth;

              bodyBookBox.style.paddingLeft = `${widthCatBox}px`;
              bodyBookBox.style.paddingRight = 0;
            },

            resetPageWhenOfBoxsTransition() {
              let self = this;
              let bodyBookBox = document.getElementsByClassName('book-viewer__body')[0];
              bodyBookBox.style.paddingLeft = 0;
              bodyBookBox.style.paddingRight = 0;
            },

            nextQuestion() {
              // Reset val for keyboard
              this.resetValKeyboard()
              if(parseInt(this.questionindexActive) < parseInt(this.questionList.length)) {
                  this.directQuestion(parseInt(this.questionindexActive) + 1);
              }
            },

            prevQuestion() {
              // Reset val for keyboard
              this.resetValKeyboard()
              if(parseInt(this.questionindexActive) > 1) {
                  this.directQuestion(parseInt(this.questionindexActive) - 1);
              }
            },

  

            directQuestion(position) {
              // Reset val for keyboard
              this.resetValKeyboard();
              let currentQuestion = this.$route.params.question;
              if(parseInt(currentQuestion) !== parseInt(position)) {
                this.question = null;
                this.arrResultCorrect = [];
                this.$router.push({name: 'exerciseOtherQuestion', params: {...this.routerParams, question: position}});
                if(this.screenWidth < 992) {
                  this.openBookCats = false;
                }
              }
            },

            async checkAnswer() {
              let self = this;
              self.resetValKeyboard();
              
              self.setQuestionList4CheckAnswer([{...self.question}])
              self.setQuestionData4CheckAnswer({...self.question})
              
              if(self.question.type === TYPE_GROUP) {
                self.txtMissingQuestionGroup = '';
                self.setQuestionData4CheckAnswer({...self.question, isGroup: true, parent: parent.questionId})
              }

              await self.setActionCheckQuestion(true);
              self.showGuideContent = true;
              
              if(self.question.isTrue) {
                  self.actionPlayQuestionTrue = true;
                  setTimeout(() => {
                      document.getElementById('question_true').play();
                  }, 5)
              } else {
                  self.actionPlayQuestionFalse = true;
                  setTimeout(() => {
                      document.getElementById('question_false').play();
                  }, 5)
              }
              // Active answer correct tab = 1
              // this.tabGuideActive = 1;
              // Update state for question:
              // console.log('Check type question: ', this.question.type, self.question.type);
              // await self.question.type === TYPE_GROUP && this.setQuestionResult();
              // if ( self.question.type === TYPE_GROUP ) {
              //     console.log('Log asadasd ', self.question)
              //     self.setResultForQuestionChild()
              // }
              // await self.question.type === TYPE_GROUP && self.setResultForQuestionChild() 
              saveUserWorkQuestion(self.question)
              // .then(res => {
              //     if(res && !res.errors) {
              //         self.$toast.success('Bạn đã hoàn thành câu hỏi ' + self.question.title);
              //     }
              // });
              setTimeout(() => {
                  self.actionPlayQuestionTrue = false;
                  self.actionPlayQuestionFalse = false;
              }, 4000)
            },

            handleAnswerMissing(valErr) {
              if(this.question.type === TYPE_GROUP) {
                this.txtMissingQuestionGroup = valErr;
              }
              setTimeout(() => {
                this.showGuideContent = false;
              }, 5)
            },

            toggleGuideContent() {
              this.showGuideContent = !this.showGuideContent;
            },

            getResultQuestion(val) {
              this.arrResultCorrect = val;
            },

            getQuestionData(val) {
              if(this.questionindexActive > 0 ) {
                  if(this.questionList[this.questionindexActive - 1] && this.questionList[this.questionindexActive - 1]['current']) {
                    this.questionList[this.questionindexActive - 1]['current'] = false;
                  }
                  if(!val) {
                    this.questionList.map(ques => {
                      ques.success && delete ques.success;
                      ques.error && delete ques.error;
                      ques.answerStatus && delete ques.answerStatus;
                    })
                  }
                  this.questionindexActive = 0;
                  this.$router.push({name: 'exerciseOtherQuestion', params: {...this.routerParams, id: this.otherId, question: 0}});
              }
              if(!this.questionsSaved) {
                this.fetchQuestionList();
              }
            },

            fetchQuestionList() {
              let self = this;
              self.setLoading(true);
              getQuestionListOfOtherOrThematic(self.otherId).then(res => {
                  if(res && res.data && !res.errors) {
                      self.questionsSaved = res.data;
                      res.data.length > 0 && localStorage.setItem( LOCAL_QUESTIONS_DATA, JSON.stringify(res.data) );
                      if (res.data && res.data.length === 0) {
                        this.handleNextPrevCat === 'next' && this.nextCatBook()
                        this.handleNextPrevCat === 'prev' && this.prevCatBook()
                      }
                  }
              }).catch().finally(() => self.setLoading(false));
            },

            async resetAnswers() {
              let self = this;
              await localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED);
              resetResultCorrectQuestionOtherOrThematic(self.otherId).then(res => {
                if(res && !res.errors) {
                  Promise.all([self.getQuestionListOfSidebar(), self.getQuestionData()]);
                  self.$toast.success('Thực hiện làm lại bài tập thành công!')
                }
              })
            },

            async directExerciseCat(val) {
              this.routerParams.question && delete this.routerParams.question
              this.$router.push({name: 'exerciseOtherDetail', params: {...this.routerParams, id: val.chapterId}})
            },

            handleActiveBookSuccess(val) {
              this.otherInfo.limitPage = 1000;
              this.otherInfo.actived = true;
            },

            handleCheckAnswerResult() {
                if(this.question.type === TYPE_GROUP) {
                  this.txtMissingQuestionGroup = '';
                }
                (this.question.type !== this.typeDrawShape && this.question.type !== this.typeDownAnswer) && this.checkAnswer();
            },

            prevCatBook() {
              this.resetValKeyboard();
              this.handleNextPrevCat = 'prev'
              if(this.indexCatCurr > 0) {
                localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED);
                this.$router.push({name: 'exerciseOtherQuestion', params: {...this.routerParams, id: this.dataCatsThematic[this.indexCatCurr - 1].chapterId, question: 0}})
              }
            },

            nextCatBook() {
                this.resetValKeyboard();
                this.handleNextPrevCat = 'next'
                if(this.indexCatCurr < this.thematicCatLength - 1) {
                  localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED);
                  this.$router.push({name: 'exerciseOtherQuestion', params: {...this.routerParams, id: this.dataCatsThematic[this.indexCatCurr + 1].chapterId, question: 0}})
                }
            },

            resetValKeyboard() {
              this.valVituralKeyboard && this.setVituralKeyVal({});
            }
        },
    }
</script>

<style lang="scss" scoped>

    #main_app {
      height: auto;
    }

    .comment-img {
      max-width: 150px;
      margin: 8px 10px;
      max-width: 165px;
      margin: 10px;
      position: relative;
      background: #e1efff;
    }
    .private-fa-times {
      position: absolute;
      top: 3px !important;
      cursor: pointer;
      right: 2px !important;
    }
    .textarea-modal {
      width: 100%;
      border: none;
    }
    .join-cls {
      background: #124abe;
      width: 110px;
      border-radius: 20px;
      height: 30px;
      line-height: 15px;
    }
    .close-cls {
      background: none;
      border: 0;
      color: #124abe;
      border-radius: 20px;
    }
    #upload-photo {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: block;
      opacity: 0;
    }

    .answer-2{
        p{
            width:160px;
        }
    }
    .questions-child {
        &__item {
            &:first-child {
                margin-top: 30px;
            }

            &:not(:last-child) {
                margin-bottom: 30px;
            }
        }
    }

    .overlay-question {

    }

    .exercise-detail {
        &__breadcrumb {
            padding-left: 15px;
            padding-right: 80px;

            @media screen and ( min-width: 576px ) and ( max-width: 991px ) {
                padding-right: 55px;
            }

            @media screen and ( max-width: 575px ) {
                padding-right: 40px;
            }

            ul li {

                @media screen and ( min-width: 576px ) and ( max-width: 991px ) {
                    width: 15%;
                }
                
                @media screen and ( max-width: 575px ) {
                    width: 25%;
                }

                a, span, &:before {
                    @media screen and ( min-width: 992px ) and ( max-width: 1199px ) {
                        font-size: 14px;
                    }
                    @media screen and ( min-width: 576px ) and ( max-width: 991px ) {
                        font-size: 12px;
                    }
                    @media screen and ( max-width: 575px ) {
                        font-size: 11px;
                    }
                }
            }
        }
        &__sidebar {
          position: absolute;
          top: 0;
        }

        &__questions {
          max-width: 80%;
          margin: 0 auto;
          padding: 30px 15px;
        }

        &__direct {
            >* {
                &:not(:first-child) {
                    margin-left: 20px;
                }
            }

            // i {
            //     @extend .position-rel;
            //     top: 3px;
            // }
        }

        &__action {
            >a {
                width: 140px;
                line-height: 1.1;
                letter-spacing: 0.03em;
                margin-left: 20px;
            }
        }

        &__back {
            margin-bottom: 20px;
            @extend .display-inline-block;
        }

        &__cats {
            &__title {
                @extend .border-0;
                @extend .margin-0;

                i {
                    margin-left: 20px;
                }
            }

            &__list {
                a {
                    width: 65px;
                    height: 35px;
                    line-height: 35px;
                    @extend .display-inline-block;
                    @extend .text-center;
                    margin-bottom: 18px;
                    @extend .font-size-15;
                    @extend .font-sanpro-semibold;
                    @extend .secondary-color-txt;
                    border: 1px solid transparent;
                    border-radius: 4px;

                    &.item {

                        &:not(:nth-child(4n)) {
                            margin-right: 10px;
                        }
                    }

                    &:hover, &.curr {
                        border-color: $primary_color;
                    }

                    &:hover, &.curr, &.success, &.error {
                      @extend .primary-color;
                    }

                    &.success {
                        @extend .secondary-bg-color;
                        border-color: $secondary_color;
                    }

                    &.error {
                        @extend .four-bg-color;
                        border-color: $four_color;
                    }
                }
            }

            &__breadcrumb {
              margin-bottom: 30px;
              ul {
                li {
                  @extend .display-flex;
                  @extend .full-width;
                  margin-bottom: 10px;
                  
                  a {
                    @extend .secondary-color-txt;
                    @extend .font-size-16;
                  }

                  .btn-reset {
                    width: 26px;
                    height: 26px;
                    @extend .display-flex-center;
                    @extend .justify-content-center;
                    @extend .border-rd-50;
                    margin-left: 20px;
                    @extend .btn-2;
                    cursor: pointer;
                  }

                  &.active {

                    a {
                      @extend .primary-color;
                      @extend .font-sanpro-semibold;
                    }
                  }

                  &:last-child {
                    a {
                      padding-top: 3px;
                      max-width: calc(100% - 45px);
                      @extend .word-excerpt;
                    }
                  }
                }
              }
            }
        }

        &__feedback {
            margin-bottom: 38px;
        }

        &__list {
            margin-bottom: 35px;
        }

        &__guide {
            h2 {
                margin-bottom: 13px;
            }

            p {
                @extend .primary-color-txt;
            }
        }

        @media screen and ( min-width: 576px ) and ( max-width: 1199px ) {
            &__cats {
                width: 365px;
            }
        }

        @media screen and ( min-width: 992px ) and ( max-width: 1199px ) {
            &__cats {
                padding: 25px 0;
            }
        }

        @media screen and ( max-width: 991px ) {
            &__body {
                padding: 0!important;
            }
            &__sidebar {
                &__icons {
                    background: transparent;
                }

                &.active {
                    webkit-transform: translate(0, 0px);
                    transform: translate(0, 0px);                    
                }
            }
        }

        @media screen and ( min-width: 576px ) and ( max-width: 991px ) {
            &__questions {
              max-width: 85%;
            }
            &__cats {
                // padding: 25px 15px;
                padding: 25px 0;
            }
            &__sidebar {
                webkit-transform: translate(75vw, 0px);
                transform: translate(75vw, 0px);
            }
        }
        @media screen and ( min-width: 768px ) and ( max-width: 991px ) {
        }

        @media screen and ( max-width: 991px ) {
            &__questions {
                padding: 25px 15px;
            }
            &__feedback {
                margin-bottom: 25px;
            }
        }

        @media screen and ( max-width: 575px ) {
            &__questions {
              max-width: 95%;
            }
            &__cats {
                width: 300px;
                // padding: 20px 10px;
                padding: 20px 0;
                -webkit-transform: translate(-300px, 0px);
                transform: translate(-300px, 0px);

                &__list {
                    a {
                        width: 55px;
                        height: 30px;
                        line-height: 30px;
                        margin-bottom: 15px;

                        &:not(:nth-child(4n+4)) {
                            margin-right: 15px;
                        }
                    }
                }
            }

            &__guide {
                h2 {
                    font-size: 20px;
                }

                &__content {
                    font-size: 15px;
                }
            }

            &__action >a {
                width: 105px;
            }

            &__direct > *:not(:first-child), &__action >a {
                margin-left: 15px;
            }

            &__sidebar {
                webkit-transform: translate(80vw, 0px);
                transform: translate(80vw, 0px);
            }
        }
  }
</style>
